export default ()=>({
    loading: false,
    windowWidth: window.innerWidth,
    query: '',
    urlParams: '',
    mobileFiltersShow: false,
    body: null,
    dropdowns: null,
    openDetailElement: null,
    filterForm: null,
    count: null,
    paginateItems: null,
    filterFormMobile: null,
    sort: null,
    collectionData: null,
    html_dom: null,
    collectionCurrentPath: null,
    init(){
        this.body = document.querySelector('body')
        this.dropdowns = document.querySelectorAll('.filter-dropdown')
        this.collectionData = JSON.parse(document.querySelector('[data-collection-json]').textContent);
        this.collectionCurrentPath =  this.collectionData.current_path;
        this.count =  this.collectionData.paginate_count;
        this.paginateItems =  this.collectionData.paginate_items
        this.filterForm = document.querySelector('[data-filter-form]')
        this.filterFormMobile = document.querySelector('[data-mobile-filter]')
        this.urlParams = new URL(window.location.href)
        // this.sortCollection()
        this.calculateProgressBarWidth(this.count, this.paginateItems)
    },
     sortCollection(){
        let queryString;
        const PageMediaQuery = window.matchMedia('(max-width: 990px)')
        if(PageMediaQuery.matches &&  this.filterFormMobile != null) {
          queryString = new URLSearchParams(new FormData(this.filterFormMobile)).toString();
       } else {
          queryString = new URLSearchParams(new FormData(this.filterForm)).toString();
       }
        this.sort = document.querySelector("#sort_by").value;
         let url =  this.collectionCurrentPath+'?sort_by=' + this.sort + '&' + queryString;
        fetch(url)
          .then(response => response.text())
          .then(data => {

            let html_div = document.createElement('div');
            html_div.innerHTML = data;

            let html_dom = html_div.querySelector('#ProductGridContainer').innerHTML;
            document.querySelector('#ProductGridContainer').innerHTML = html_dom;

            // update url without refreshing the page
            history.replaceState(null, null, '?sort_by=' + this.sort + '&' + queryString);
          })
          .catch(error => console.error('Error:', error))
          .finally(() => {
              this.updateYotpo();
              this.loading = false
          });
      },
        updateYotpo(){
            (window.yotpoWidgetsContainer || window.yotpo).initWidgets();
        },
      calculateProgressBarWidth(count, paginateItems){
        return (count * 100) / parseInt(paginateItems)  + '%'
      },
      updateFilter(event){
        this.sort = document.querySelector("#sort_by").value;
        const PageMediaQuery = window.matchMedia('(max-width: 990px)')
        let queryString;
        if(PageMediaQuery.matches &&  this.filterFormMobile != null) {
            queryString = new URLSearchParams(new FormData(this.filterFormMobile)).toString();
         } else {
            queryString = new URLSearchParams(new FormData(this.filterForm)).toString();
         }
         this.query = queryString;

          fetch( this.collectionCurrentPath + '?' + this.query + '&sort_by=' + this.sort)
          .then(response => response.text())
          .then(data => {

            let html_div = document.createElement('div');
            html_div.innerHTML = data;

            let html_dom = html_div.querySelector('#ProductGridContainer').innerHTML;
            document.querySelector('#ProductGridContainer').innerHTML = html_dom;
            let filter_html = html_div.querySelector('.mobile-filters__container').innerHTML;
            document.querySelector('.mobile-filters__container').innerHTML = filter_html;

            let activeFilters =  html_div.querySelector('[data-active-filters-wrap]').innerHTML;
            document.querySelector('[data-active-filters-wrap]').innerHTML = activeFilters;

            let filterDropdownValuesNew =  html_div.querySelectorAll('.filter-dropdown__values');
            let filterDropdownValuesCurrent =  document.querySelectorAll('.filter-dropdown__values');
            filterDropdownValuesCurrent.forEach((element, index) => {
              element.innerHTML = filterDropdownValuesNew[index].innerHTML;
            });

            let dataProductDesktopNew = html_div.querySelectorAll('[data-product-desktop]');
            let dataProductDesktopCurrent =  document.querySelectorAll('[data-product-desktop]');
            dataProductDesktopCurrent.forEach((element, index) => {
              element.innerHTML = dataProductDesktopNew[index].innerHTML;
            });

            // update url without refreshing the page
            history.pushState(null, null, '?' + this.query + '&sort_by=' + this.sort);

          })
          .catch(error => console.error('Error:', error))
          .finally(() => {
              this.loading = false
              this.updateYotpo();
          });
      },
      clearFilter(){
         this.loading = true;
         let url =  this.collectionCurrentPath;
        this.pushFilter(url);
      },
      pushFilter(newUrl){
        this.loading = true;

        fetch(newUrl)
          .then(response => response.text())
          .then(data => {
            let html_div = document.createElement('div');
            html_div.innerHTML = data;

            let html_dom = html_div.querySelector('#ProductGridContainer').innerHTML;

            document.querySelector('#ProductGridContainer').innerHTML = html_dom;

            let filter_html = html_div.querySelector('.mobile-filters__container').innerHTML;
            document.querySelector('.mobile-filters__container').innerHTML = filter_html;

            let activeFilters =  html_div.querySelector('[data-active-filters-wrap]').innerHTML;
            document.querySelector('[data-active-filters-wrap]').innerHTML = activeFilters;

            let filterDropdownValuesNew =  html_div.querySelectorAll('.filter-dropdown__values');
            let filterDropdownValuesCurrent =  document.querySelectorAll('.filter-dropdown__values');
            filterDropdownValuesCurrent.forEach((element, index) => {
              element.innerHTML = filterDropdownValuesNew[index].innerHTML;
            });

            let dataProductDesktopNew = html_div.querySelectorAll('[data-product-desktop]');
            let dataProductDesktopCurrent =  document.querySelectorAll('[data-product-desktop]');
            dataProductDesktopCurrent.forEach((element, index) => {
              element.innerHTML = dataProductDesktopNew[index].innerHTML;
            });

            // update url without refreshing the page
            history.pushState(null, null, newUrl);

          })
          .catch(error => console.error('Error:', error))
          .finally(() => {
            let queryString = new URLSearchParams(new FormData(this.filterForm)).toString();
            this.query = queryString
              this.updateYotpo();
            this.loading = false
          });
      },
      loadMore(NextUrl){
        this.loading = true;
        fetch(NextUrl)
          .then(response => response.text())
          .then(data => {
            let html_div = document.createElement('div');
            html_div.innerHTML = data;

            const button = document.querySelector('#product_pagination .button');
            const href = button.getAttribute('href');
            const url = new URL(href, window.location.origin);
            const pageValue = url.searchParams.get('page');
            if(pageValue && parseInt(pageValue) === parseInt(button.getAttribute('data-total-pages'))) {
              document.querySelector('#product_pagination').style.display = 'none';
            }

            let html_dom = html_div.querySelector('#product_grid').innerHTML;
            document.querySelector('#product_grid').innerHTML += html_dom;

            if (html_div.querySelector('#product_pagination')){
                let pagination_dom = html_div.querySelector('#product_pagination').innerHTML;
                if(document.querySelector('#product_pagination')) {
                document.querySelector('#product_pagination').innerHTML = pagination_dom;
              }
            }
          })
          .catch(error => console.error('Error:', error))
          .finally(() => {
            this.updateYotpo();
            this.loading = false

          });
      },
    openMobileFilters(){
        this.mobileFiltersShow = true
        this.body.style.overflow = 'hidden'
    },
    closeMobileFilters(){
        this.mobileFiltersShow = false
        this.body.style.overflow = 'visible'
    },
    switchProductGridLayout(tirgerButton, productGrid){
      let allButns = document.querySelectorAll('[data-button-cols]')
      allButns.forEach(button => {
        button.classList.remove('active')
      });
      tirgerButton.classList.add('active')
      let gridColsCount =  tirgerButton.getAttribute('data-button-cols')
      productGrid.setAttribute('data-grid-cols', gridColsCount)
    }
})



